import { ReactNode } from 'react'

export type Wrapper = (content: ReactNode) => ReactNode

const noopWrapper: Wrapper = content => content

export default noopWrapper
